import React from 'react';
import styles from './HomepageMobileAppsMessage.scss';
import appStoreBadge from 'Static/images/badges/app-store-badge.svg';
import microsoftBadge from 'Static/images/badges/microsoft-badge.svg';
import googlePlayBadge from 'Static/images/badges/google-play-badge.png';

const HomepageMobileAppsMessage = () => {
  return (
    <div className="HomepageMobileAppsMessage">
      <div className="HomepageMobileAppsMessage__Content">
        <div>
          <p className="TextPageHeader__paragraph">
            Tinybop Schools interactive models <em>require</em> a desktop or
            laptop with internet access.
          </p>
          <p className="TextPageHeader__paragraph">
            On your tablet or mobile device you may navigate the site and your
            account, accessing classes, resources, materials, and activities.
          </p>
          <p className="TextPageHeader__paragraph">...</p>
          <p className="TextPageHeader__paragraph">
            Our full library of apps is available on iOS, and select apps are on
            Google Play and Microsoft.
          </p>
        </div>
        <div className="HomepageMobileAppsMessage__Badges">
          <div>
            <a href="https://apps.apple.com/us/developer/tinybop-inc/id682046582">
              <img src={appStoreBadge} alt="Download on the App Store" />
            </a>
          </div>
          <div>
            <a href="https://play.google.com/store/apps/dev?id=6253744575658539819">
              <img src={googlePlayBadge} alt="Download on Google Play" />
            </a>
          </div>
          <div>
            <a href="https://www.microsoft.com/en-us/search/shop/apps?q=tinybop">
              <img src={microsoftBadge} alt="Download on Microsoft" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageMobileAppsMessage;
